<svg
  width="50"
  height="50"
  viewBox="0 0 50 50"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <rect x="11" y="13" width="28" height="6" rx="3" fill="#2474BB" />
  <rect x="11" y="22" width="28" height="6" rx="3" fill="#2474BB" />
  <rect x="11" y="31" width="28" height="6" rx="3" fill="#2474BB" />
</svg>
